import { useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { Box, Button, Stack } from "@mui/material";

import { FormSelectField } from "@covertree/ui";
import { UnitLevelUnderwritingAnswers } from "@covertree/types";

import { QuestionModalProps } from "../underwritingQuestions";
import { mapQuestionOptionsToFormOptions } from "../../../mappings/underwritingQuestionsMaps";
import { UnderwritingQuestionsForm } from "../../../validatorsAndTypes/underwritingQuestions";

export function TrampolineForm({ questions, closeModal }: QuestionModalProps) {
  const { formState, watch, control } =
    useFormContext<UnderwritingQuestionsForm>();
  const safetyNet = watch("trampolineSafetyNet");
  const safetyNetOptions = useMemo(
    () =>
      mapQuestionOptionsToFormOptions(
        questions?.[UnitLevelUnderwritingAnswers.TrampolineSafetyNet].options
      ),
    [questions]
  );
  const liabilityExtensionOptions = useMemo(
    () =>
      mapQuestionOptionsToFormOptions(
        questions?.[UnitLevelUnderwritingAnswers.TrampolineLiabilityExtension]
          .options
      ),
    [questions]
  );

  return (
    <Stack spacing={4}>
      <Box>
        <FormSelectField
          control={control}
          name="trampolineSafetyNet"
          id="has-maintained-safety-net"
          dataTestId="has-maintained-safety-net"
          options={safetyNetOptions}
          label="Does the trampoline have a maintained safety net?"
        />
      </Box>
      {safetyNet === "Yes" && (
        <Box>
          <FormSelectField
            control={control}
            name="trampolineLiabilityExtension"
            id="wants-trampoline-liability-coverage"
            dataTestId="wants-trampoline-liability-coverage"
            options={liabilityExtensionOptions}
            label="Do you want liability coverage with the trampoline?"
          />
        </Box>
      )}
      <Box>
        <Button
          type="button"
          onClick={closeModal}
          disabled={!formState.isValid}>
          Save
        </Button>
      </Box>
    </Stack>
  );
}
